//ENUMS BEGIN ========================
export enum QuestionActionOnFailure {
    next = "next",
    fallback = "fallback"
}

export enum ResponseButtonType {
    goto = 'goto',
    url = 'url',
    phone = 'phone',
    postback = 'postback'
}

export enum TagsElementAction {
    ADD = "add",
    REMOVE = "remove",
    REMOVE_ALL = "remove-all",
}

export enum ButtonType {
    goto = 'goto',
    url = 'url',
    phone = 'phone',
    postback = 'postback',
    imBack = 'imBack'
}

export enum ICardMediaType {
    IMAGE = "image",
    VIDEO = "video"
}

export enum SetAttributeAction {
    set = 'set',
    remove = 'remove',
}

export enum RecognizerScope {
    root = 'root',
    subsequent = 'subsequent'
}

export enum ButtonActionType {
    'tag' = 'tag',
    'attribute' = 'attribute',
}

export enum StepsBDMedicalAppointment {

    appointmentType = "appointmentType",

    organizationUnit = "organizationUnit",
    organizationUnit_search = "organizationUnit_search",

    insurance = "insurance",
    insurance_search = "insurance_search",
    insurance_suggestion = "insurance_suggestion",

    insurancePlan = "insurancePlan",
    insurancePlan_search = "insurancePlan_search",

    insuranceSubPlan = "insuranceSubPlan",
    insuranceSubPlan_search = "insuranceSubPlan_search",

    planCategory = "planCategory",
    planCategory_search = "planCategory_search",

    speciality = "speciality",
    speciality_search = "speciality_search",

    doctor = "doctor",
    doctor_search = "doctor_search",
    doctor_suggestion = "doctor_suggestion",

    procedure = "procedure",
    procedure_search = "procedure_search",

    occupationArea = "occupationArea",
    occupationArea_search = "occupationArea_search",

    organizationUnitLocation = "organizationUnitLocation",
    organizationUnitLocation_search = "organizationUnitLocation_search",

    typeOfService = "typeOfService",
    typeOfService_search = "typeOfService_search",

    appointment = "appointment",

    choose_day_period = "choose_day_period",
    choose_doctor = "choose_doctor",

    confirmAppointment = "confirmAppointment",

    reuseAppointments = "reuseAppointments",
    appointmentValue = "appointmentValue",

    test = "test"
}

export enum AppointmentSortTypes {
    default = 'default',
    firstEachPeriodDay = 'firstEachPeriodDay',
    firstEachAnyPeriodDay = 'firstEachAnyPeriodDay',
    firstEachHourDay = 'firstEachHourDay',
    sequential = 'sequential',
    combineDatePeriodByOrganization = 'combineDatePeriodByOrganization',
}

//ENUMS END ========================


//SHARED RESPONSES INTERFACES BEGIN =====================
export interface IResponseElement {
    _id?: string;
}

export interface IResponseButton {
    type?: ResponseButtonType;
    title?: string;
    value?: string;
}


export interface IButtonAction {
    type: ButtonActionType;
    element: IResponseElementSetAttribute | IResponseElementTags
}
export interface IButton {
    type: ButtonType,
    title: string,
    value: any,
    index?: number;
    actions?: Array<IButtonAction>;
}

export interface ICardMedia {
    type: ICardMediaType
    url: string;
    autoPlay: boolean;
    autoLoop: boolean;
}
export interface ICard {
    title?: string;
    subtitle?: string;
    text?: string;
    buttons?: IButton[];
    media?: ICardMedia;
    imageUrl?: string;
}

export interface SwitchText {
    case: string;
    text: string[];
}

export interface IHttpHookResponseHeader {
    name: string;
    value: string;
}
//SHARED RESPONSES INTERFACES END =====================

//DEFAULT RESPONSES BEGIN ===================================
export interface IResponseElementSwitchText extends IResponseElement {
    name: string;
    default: string[];
    switch: SwitchText[];
    type: string;
}

export interface IResponseElementCard extends IResponseElement, ICard {
    buildAsQuickReply?: boolean;
}

export interface IResponseElementCarrousel extends IResponseElement, ICard {
    cards: ICard[]
}

export interface IResponseElementSetAttribute extends IResponseElement {
    name?: string;
    action?: SetAttributeAction;
    value?: string;
    type?: string;
    label?: string;
}

export interface IResponseElementText extends IResponseElement {
    text?: string[];
}

export interface IResponseElementImage extends IResponseElement {
    imageUrl: string;
}

export interface IResponseElementVideo extends IResponseElement {
    videoUrl: string;
}

export interface IResponseElementCarousel extends IResponseElement { }

export interface IResponseSendEmail extends IResponseElement {
    emailDestination: string;
}

export interface IResponseElementTags extends IResponseElement {
    action: TagsElementAction;
    name: string;
    color: string;
}

export interface IResponseElementWebhook extends IResponseElement {
    webhookId?: string;
}

export interface IResponseElementQuestion extends IResponseElementText {
    name?: string;
    lifespan?: number;
    entity?: string;
    askWhenFilled?: boolean;
    actionOnFailure?: QuestionActionOnFailure;
    required?: boolean;
    text?: string[];
    errorMessages?: string[];
}

export interface IResponseElementGoto extends IResponseElement {
    value?: string;
    workspaceId?: string;
    botId?: string;
}

export interface IResponseElementPostback extends IResponseElement {
    value?: string;
}

export interface IResponseElementHttpHook extends IResponseElement {
    url: string;
    method: string;
    headers: Array<IHttpHookResponseHeader>;
    body?: any;
    attrType: string;
    attrName: string;
}

export interface IResponseElementSetRecognizerScope extends IResponseElement {
    value?: RecognizerScope
}

export interface IResponseElementFaq extends IResponseElement {
    faqId: string;
    criteria: any;
    attrName: string;
    attrType: string;
}

export interface IResponseElementAdaptiveCard extends IResponseElement {
    attachment: any;
}

export interface IResponseElementPrintScreen extends IResponseElement {
    text: string[];
}

export interface IResponseElementEndConversation extends IResponseElement {
    showRating: boolean;
    isClosedByUser?: boolean;
    customMessages?: {
        rating?: {
            title?: string;
            description?: string;
        },
        confirmation?: {
            title?: string;
            description?: string;
            showAvatar?: boolean;
        }
    }
}

export interface IResponseElementRating extends IResponseElement {
    customMessages?: {
        rating?: {
            title?: string;
            description?: string;
        },
        confirmation?: {
            title?: string;
            description?: string;
            showAvatar?: boolean;
        }
    }
}

export interface IResponseElementTransboard extends IResponseElement {
    /**
     * Id do channel que vai ser transbordado
     * Ex: live-agent, whatsweb, webchat
     */
    channelId: string;

    /**
     * Id ou token do channelConfig que será tranbordado
     */
    channelConfigId: string;

    /**
     * Id da interaction que tem que ir quando não pode ser transbordado
     */
    cannotTransboardGoto: string;
}

export interface IResponseElementConversationAssigned extends IResponseElement {
    /**
     * Id do time que deve ser transferido
     */
    teamId: string;

    /**
     * Id do usuario do time que deve ser transferido
     */
    userId?: string;

    /**
     * Prioridade do atendimento
     */
    priority?: string;

    /**
     * Id da interaction que tem que ir quando não pode ser transferido
     */
    cannotAssignGoto: string;

    /**
     * Mensagem que será encaminhada para o usuário caso não esteja no horario de atendimetno do time 
     * */
    cannotAssignMessage: string;

    /*Interaction que vai quando janela do whatsapp estiver próxima de encerrar*/
    cannotAssignOptinLimit?: string;

    /** Vai apenas validar o periodo de atendimento sem assinar para o time */
    onlyValidateAttendance?: boolean;

    /** Vai desabilitar os campos cannotAssignMessage, userId, cannotAssignOptinLimit se for === 2 */
    version?: number;

}

export interface IResponseElementTemplate extends IResponseElement {
    templateId: string;
}

export interface IResponseElementCampaignEvent extends IResponseElement {
    data: string;
}

export interface IResponseElementComment extends IResponseElement {
    comment: string[];
}

export interface IResponseElementReassignConversation extends IResponseElement {
    teamId: string;
}

export interface IResponseElementPrivacyPolicy extends IResponseElement {}

//DEFAULT RESPONSES END ===================================

//HOSPITALITY RESPONSES BEGIN ==============================

export interface IResponseElementRoomRate extends IResponseElement {
    hotelsId: Array<string>;
    cityId?: Array<string>;
    chainId: string;
    promoCode: string;
    roomRateText: string;
    roomsFoundMessage?: string;
    notFoundMessage?: string;
}

export interface IResponseElementHotelInfo extends IResponseElement {
    chainId: string;
    hotelsId: Array<string>;
    cityId: Array<string>;
    roomRateText: string;
    promoCode?: string;
    roomsFoundMessage?: string;
    notFoundMessage?: string;
}

export interface FieldDetails {
    required: boolean;
    visible: boolean;
    label: string;
}

export interface IResponseElementBookingConfirmation extends IResponseElement {
    emailDestination: string;
    reservationOrigin: Array<{ title: string, value: string }>;
    subject: string;
    successMessage: string;
    fields: {
        bookingSource: FieldDetails;
        bookingName: FieldDetails;
        arrivalDate: FieldDetails;
        bookingEmail: FieldDetails;
    }
}

export interface IResponseElementBookingCancellation extends IResponseElement {
    emailDestination: string;
    subject: string;
    successMessage: string;
    label: string;
    fields: {
        bookingName: FieldDetails;
        bookingEmail: FieldDetails;
        arrivalDate: FieldDetails;
        bookingNumber: FieldDetails;
    }
}

//HOSPITALITY RESPONSES END ==============================
//HEALTH RESPONSES BEGIN =================================
export interface IResponseElementGuiaMedico extends IResponseElement {
    random: boolean;
    limit: number;
    healthPlan: string;
    cityAttribute?: string;
    specialityAttribute?: string;
    specializedServiceAttribute?: string;
    serviceCodeAttribute?: string;
    providerAttribute?: string;
    isEmptyGoto?: string;
    successMessage?: string[];
    rules: Array<{
        name: string;
        value: any;
    }>;
    shouldReturnCnpj: boolean;
}

export interface IResponseElementStatusGuia extends IResponseElement {
    medicalPlan: string;
    guideStatus: Array<{
        case: string;
        text: string[];
    }>;
    isEmptyGoto: string;
    guideNumber: string;
    shouldReturnBeneficiarioNumber: boolean;
}

export interface IResponseElementGuiasBeneficiario extends IResponseElement {
    medicalPlan: string;
    isEmptyGoto: string;
    beneficiarioNumber: string;
}

export interface IResponseElementQRBuscaFornecedor extends IResponseElement {
    cnpjAttr: string;
    idProcessoAttr?: string;
    serviceAddress: string;
    panelId: string;
    isEmptyGoto?: string;
}
export interface IResponseElementQRBuscaId extends IResponseElement {
    idAttr: string;
    saveOnAttr: string;
}


// ===================== manager system responses START
export enum MSAppointmentType {
    'appointment' = 'appointment',
    'procedure' = 'procedure',
    'all' = 'all',
}
export interface IResponseElementMedicalAppointment extends IResponseElement {
    serviceEndpointAttrName?: string,
    serviceUsernameAttrName?: string,
    servicePasswordAttrName?: string,
    appointmentType?: MSAppointmentType;
    attrNameName?: string,
    attrNameSex?: string,
    attrNamePeso?: string;
    attrNameStep?: string,
    attrNameDiaSemana?: string,
    attrNamePhone?: string;
    attrNameMotherName?: string,
    attrNameAgendamentoIniciado?: string,
    attrNameReiniciarAgendamento?: string,
    attrNameAgendamentoFinalizado?: string,
    attrNameUnidadeHandler?: string,
    attrNameConvenioHandler?: string,
    attrNamePlanoHandler?: string;
    attrNameProcedimentoHandler?: string,
    attrNameEspecialidadeHandler?: string,
    attrNameRecursoHandler?: string,
    attrNameGrupoServicoHendler?: string,
    attrNameTipoAgendamento?: string,
    attrNamePeriodoDia?: string,
    attrNameTelefone?: string,
    attrNameDataNascimento?: string,
    attrNameCpf?: string,
    attrNameEmail?: string,
    transferToHumanGoto?: string,
    isAgendamentoNaoConfirmadoGoto?: string,
    isErrorGoto?: string,
    isEmptyGoto?: string,
    notAccountGoto?: string;
    appointmentsOrderByRecent?: boolean;
}

export interface IResponseElementMngsAccount extends IResponseElement {
    serviceEndpointAttrName?: string,
    serviceUsernameAttrName?: string,
    servicePasswordAttrName?: string,

    attrNameId?: string,
    attrNameDataNascimento?: string,
    attrNameSex?: string,
    attrNameName?: string,
    attrNameCpf?: string,
    attrNameEmail?: string,
    attrNamePhone?: string,

    saveTokenOnAttr?: string,
    transferToHumanGoto?: string,
    isErrorGoto?: string,
    accountCreatedGoto: string,
    isEmptyGoto?: string,
}

export interface IResponseElementMngsCheckAccount extends IResponseElement {

    serviceEndpointAttrName: string,
    serviceUsernameAttrName: string,
    servicePasswordAttrName: string,

    attrNameCpf: string,

    attrNameId?: string,
    attrNameDataNascimento?: string,
    attrNameSex?: string,
    attrNameName?: string,
    attrNameEmail?: string,
    attrNamePhone?: string,
    attrNameConvenioHandle?: string,
    attrNameAgendamentoFuturo?: string,

    transferToHumanGoto?: string,
    isErrorGoto: string,
    accountExistsGoto: string,
    accountNotExistsGoto: string,
}

export interface IResponseElementMngsCheckAppointment extends IResponseElement {

    serviceEndpointAttrName: string,
    serviceUsernameAttrName: string,
    servicePasswordAttrName: string,

    attrNameCpf: string,
    attrNameId?: string,
    attrNameDataNascimento?: string,

    attrNameTypeCheck?: string,

    isErrorGoto: string,
    isEmptyGoto?: string,
    actionIgnoredGoto?: string,
    accountNotExistsGoto: string,
}
// ===================== manager system responses END
// ===================== Netpacs responses START
export interface IResponseElementNetpacsMedicalAppointment extends IResponseElement { }
// ===================== Netpacs responses END

export interface IResponseElementBDPatientCreation extends IResponseElement {
    integrationCode?: string,
    integrationId?: string,

    attrNameBornDate: string;
    attrNameSex?: string,
    attrNameName?: string,
    attrNameColor?: string,
    attrNameMotherName?: string;
    attrNameCpf?: string,
    attrNameWeight?: string;
    attrNameHeight?: string;
    attrNameEmail?: string,
    attrNamePhone?: string,
    attrNameCellPhone?: string,
    identityNumber?: string;
    saveTokenOnAttr?: string,
    transferToHumanGoto?: string,
    isErrorGoto?: string,
    accountCreatedGoto: string,
    isEmptyGoto?: string,
    url?: string;
}

export interface IResponseElementBDCheckAccount extends IResponseElement {
    url?: string;
    integrationCode?: string,
    integrationId?: string,

    attrNameCpf: string,
    attrNameBornDate: string;
    attrNameSex?: string;
    attrNameWeight?: string;
    attrNameHeight?: string;
    attrNameName?: string;
    attrNameEmail?: string;
    attrNamePhone?: string;
    attrNameId?: string;
    attrNameColor?: string;
    attrNameMotherName?: string,

    isErrorGoto: string,
    accountExistsGoto: string,
    accountExistsDataMismatchGoto: string,
    accountNotExistsGoto: string,
    accountMismatchGoto?: string,

    attrNameLastAppointmentDate?: string;
    attrNameNextAppointmentDate?: string;

    attrNameLastAppointmentSpecialityCode?: string;
    attrNameNextAppointmentSpecialityCode?: string;
}

export enum BDAppointmentListActionType {
    view = 'view',
    confirm = 'confirm',
    cancel = 'cancel',
    rescheduled = 'rescheduled',
    return = 'return',
}

export interface IResponseElementBDAppointmentList extends IResponseElement {
    url?: string;
    integrationId?: string;
    attrNameCpf: string;
    attrNameName?: string;
    attrNameColor?: string;
    attrNamePhone?: string;
    attrNameMotherName?: string,
    attrNameId?: string;
    attrNameBornDate?: string;
    attrNameActionType?: BDAppointmentListActionType;
    isErrorGoto: string;
    cannotDoActionGoto?: string;
    isEmptyGoto?: string;
    actionIgnoredGoto?: string;
    accountNotExistsGoto: string;
    isRescheduledGoto?: string;
    isSheduledGoto?: string;
    attrNameOccupationArea?: string;
    attrNameOrganizationUnitLocation?: string;
    attrNameScheduleToCancelCode?: string,
    attrNameAppointmentType?: string,
    attrNameOrganizationUnit?: string,
    attrNameInsurance?: string,
    attrNameInsurancePlan?: string,
    attrNameInsuranceSubPlan?: string,
    attrNamePlanCategory?: string,
    attrNameSpeciality?: string,
    attrNameProcedure?: string;
    attrNameChooseDoctor?: string,
    attrNameDoctor?: string,
    attrNamePatientId?: string,
    attrName?: string,
    attrNamePeriodOfDay?: string,
    attrNameTypeOfService?: string,
    attrNameDateLimit?: string,
}

export interface IResponseElementBDMedicalScale extends IResponseElement {
    integrationUrl?: string,
    integrationId?: string,
    isEmptyGoto?: string;
    isErrorGoto?: string;
    url?: string;
}

export interface IResponseElementBDReasonForNotScheduling extends IResponseElement {
    integrationUrl?: string,
    integrationId?: string,
    isEmptyGoto?: string;
    isErrorGoto?: string;

    attrNamePhone?: string,
    attrNameName?: string;
    attrNameBornDate?: string,
    attrNameCpf?: string,
    attrNameMotherName?: string,
    attrNameSex?: string,

    attrNameStep?: string;
    attrNameOccupationArea?: string;
    attrNameOrganizationUnitLocation?: string;
    attrNameAppointmentType?: string,
    attrNameOrganizationUnit?: string,
    attrNameInsurance?: string,
    attrNameInsurancePlan?: string,
    attrNameInsuranceSubPlan?: string,
    attrNamePlanCategory?: string,
    attrNameSpeciality?: string,
    attrNameProcedure?: string;
    attrNameChooseDoctor?: string,
    attrNameDoctor?: string,
    attrNamePeriodOfDay?: string,
    attrNameTypeOfService?: string
    attrNameReason?: string;
    attrNameReasonText?: string;
}

export interface IResponseElementBDPatientIdentification extends IResponseElement {
    integrationUrl?: string,
    integrationId?: string,
    
    type: 'requestAcceptance' | 'preload' | 'removeAcceptance';
    
    attrNameCode?: string;
    attrNameName?: string;
    attrNamePhone?: string,
    attrNameBornDate?: string,
    attrNameCpf?: string,
    attrNameSex?: string;
    attrNameWeight?: string;
    attrNameHeight?: string;
    attrNameEmail?: string;
    attrNameColor?: string;
    attrNameMotherName?: string,

    isAcceptedGoto?: string;
    isRejectedGoto?: string;
    isRequestedAcceptance?: string;
    isNotRequestedAcceptance?: string;
    isErrorGoto?: string;
    isRequestedRevalidation?: string;

    accountExistsGoto?: string,
    accountExistsDataMismatchGoto?: string,
    accountNotExistsGoto: string,
    accountMismatchGoto?: string,

    attrNameLastAppointmentDate?: string;
    attrNameNextAppointmentDate?: string;

    attrNameLastAppointmentSpecialityCode?: string;
    attrNameNextAppointmentSpecialityCode?: string;
}

export interface IResponseElementBDMedicalAppointmentBase extends IResponseElement {
    steps: Array<StepsBDMedicalAppointment>;
    url?: string;
    integrationCode?: string,
    integrationId?: string,
    appointmentType?: MSAppointmentType;

    attrNameStep?: string,
    attrNameWeekDay?: string,
    attrNameStartedAppointment?: string,
    attrNameRestartAppointment?: string,
    attrNameFinishedAppointment?: string,

    attrNameAppointmentType?: string,
    attrNameOrganizationUnit?: string,
    attrNameInsurance?: string,
    attrNameInsurancePlan?: string,
    attrNameInsuranceSubPlan?: string,
    attrNamePlanCategory?: string,
    attrNameSpeciality?: string,
    attrNameProcedure?: string;
    attrNameChooseDoctor?: string,
    attrNameDoctor?: string,
    attrNameOccupationArea?: string;
    attrNameOrganizationUnitLocation?: string;
    attrNamePatientId?: string,
    attrNameAppointment?: string,
    attrNamePhone?: string,
    attrNameName?: string;
    attrNameBornDate?: string,
    attrNameCpf?: string,
    attrNameMotherName?: string,
    attrNameSex?: string,
    attrNameWeight?: string,
    attrNameHeight?: string,
    attrNameEmail?: string,
    attrNameInsuranceNumber?: string,
    attrNamePeriodOfDay?: string,
    attrNameTypeOfService?: string,

    attrNameScheduleToCancelCode?: string,
}

// ===================== Botdesigner health responses START
export interface IResponseElementBDMedicalAppointment extends IResponseElementBDMedicalAppointmentBase {
    jumpSpecialityOneItem?: boolean;
    transferToHumanGoto?: string,
    isErrorGoto?: string,
    isEmptyGoto?: string,
    cannotDoActionGoto?: string;
    isAgendamentoNaoConfirmadoGoto?: string,
    onConfirmAppointmentValueGoto?: string;
    onRejectAppointmentValueGoto?: string;
    onEmptySearchRestartGoto?: string;

    checkAccountGoto?: string,
    fromDay?: number;
    untilDay?: number;
    randomize?: boolean;
    limit?: number;
    
    sortMethod?: AppointmentSortTypes;
    attrNameDateLimit?: string,
}

export interface IResponseElementBDResetMedicalAppointment extends IResponseElementBDMedicalAppointmentBase {
   
}

// ===================== Botdesigner health responses END
//HEALTH RESPONSES END ===================================


export interface IResponseElementBDConfirmation extends IResponseElement {
    integrationId: string;
    url: string;
}

export interface IResponseElementBDCheckDoctor extends IResponseElement {
    integrationId: string;
    url: string;
    attrNamePhone: string;
    attrNameDocNumber: string;
    attrNameDoctorData: string;
    notFindedDoctorGoto: string;
    askDocNumberGoto?: string;
    gotoCpfQuestion?: string;
}

export interface IResponseElementBDListDoctorSchedules extends IResponseElement {
    integrationId: string;
    url: string;
    attrNameDoctorData: string;
}

export interface IResponseElementBDPatientRecoverPassword extends IResponseElement {
    url: string;
    integrationId: string;

    attrNameCpf: string;
    attrNameBornDate: string;

    attrNameMotherName?: string;
    attrNamePhone?: string;
    attrNameEmail?: string;
    attrNameZipCode?: string;
    attrNameInsuranceNumber?: string;

    isErrorGoto: string;
}

export interface IResponseElementSapIntegration extends IResponseElement {    
    attrRequesitionNumber: string;
    attrPhoneNumberDebug: string;

    isErrorGoto: string;
  }
  